import { render } from "./AccesoMesas.vue?vue&type=template&id=d2bf45f6&scoped=true"
import script from "./AccesoMesas.vue?vue&type=script&lang=js"
export * from "./AccesoMesas.vue?vue&type=script&lang=js"

import "./AccesoMesas.vue?vue&type=style&index=0&id=d2bf45f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2bf45f6"]])

export default __exports__